import React, { useState, useEffect } from 'react';
import sanityClient from '../client.js';

// Project jsx will take backend data from post.js

const Project = () => {
	const [projectData, setProjectData] = useState(null);

	useEffect(() => {
		sanityClient
			.fetch(
				`*[_type == 'post']{
			title,
			date,
			place,
			technology,
			description,
			projectType,
			link,
			tags,
			mainImage{
				asset->{
					_id,
					url
				},
				alt
			}
		}`
			)
			.then((data) => setProjectData(data))
			.catch(console.error);
	}, []);

	return (
		<main id='project' className='min-h-screen px-6 my-28'>
			<section className='container mx-auto'>
				<h1 className='text-4xl mb-28 flex justify-center font-cursive sm:text-5xl md:text-6xl'>
					My Projects
				</h1>
				<section className='grid grid-cols-1 gap-8 mt-8 md:grid-cols-2 xl:grid-cols-3'>
					{projectData &&
						projectData

							.map((project, index) => (
								<article
									key={index}
									className='relative rounded-lg shadow-md bg-white'
								>
									<img
										src={project.mainImage.asset.url}
										alt={project.mainImage}
										className='w-full h-96 mb-4 shadow-md rounded-md object-cover'
									/>

									<h3
										className='text-gray-800 text-xl font-bold mb-2 hover:text-red-700 text-center sm:text-2xl md:text-3xl
								lg:text-2xl'
									>
										{project.title}
									</h3>
									<div className='divide-x-4 w-20 h-2  bg-gradient-to-r from-cyan-500 to-blue-500 rounded-md mx-auto my-4'></div>
									<div className='text-gray-500 text-sm space-x-4'>
										<div className='flex space-x-4 justify-center items-center mx-4 sm:text-lg md:text-xl lg:text-lg'>
											<span>
												<strong className='font-bold'>Completion Date</strong>:{' '}
												{new Date(project.date).toLocaleDateString()}
											</span>
											<span>
												<strong className='font-bold'>Project Type</strong>:{' '}
												{project.projectType}
											</span>
											<span>
												<strong className='font-bold'>Stack</strong>:{' '}
												{project.technology}
											</span>
										</div>
										<p className='my-4 text-gray-700 leading-relaxed text-center sm:text-lg md:text-xl lg:text-lg'>
											{project.description}
										</p>
										<div className='flex space-x-4 items-center justify-center mb-2 '>
											<div className='flex space-x-2 py-4'>
												<a
													href={project.link}
													target='_blank'
													rel='noopener noreferrer'
													className='text-red-500 cursor-pointer font-bold hover:underline hover:text-red-400 text-xl md:text-2xl lg:text-xl '
												>
													View The Project{' '}
												</a>
												<span role='img' aria-label='right pointer'>
													👉
												</span>
											</div>
										</div>
									</div>
								</article>
							))
							.sort((a, b) => (a._id > b._id ? 1 : -1))}
				</section>
			</section>
		</main>
	);
};

export default Project;
